import PageMain from '../components/Navigation/PageMain/PageMain';
import { ChangeSicNumber } from '../components/Settings/ChangeSicNumber/ChangeSicNumber';

export function ChangeSicNumberPage() {
    return (
        <PageMain pageTitle="My StayInContact Phone Number" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ChangeSicNumber />
                </div>
            </div>
        </PageMain>
    );
}
